if (!customElements.get("localization-form-language")) {
  class LocalizationFormLang extends HTMLElement {
    constructor() {
      super();

      // This event listener is scoped to this instance by using 'this'
      this.addEventListener('click', event => {
        const langElement = this.querySelector('.localization-selector-mobile');
        if (langElement) {
          langElement.setAttribute('aria-expanded', 'true');
          if (!langElement.contains(event.target)) {
            langElement.open = false;
            langElement.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Handle keyup events within this instance
      this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      // Set up click listeners on all anchor elements within this instance
      this.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      const langElement = this.querySelector('.localization-selector-mobile');
      if (langElement) {
        langElement.open = false;
        langElement.setAttribute('aria-expanded', 'false');
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (form) {
        this.input.value = event.currentTarget.dataset.value;
        form.submit();
      }
    }
  }

  customElements.define('localization-form-language', LocalizationFormLang);
}
